var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticStyle: {
              "padding-bottom": "5px",
              display: "flex",
              width: "100%",
              "align-content": "stretch",
              "flex-direction": "row",
              "flex-wrap": "wrap",
              "justify-content": "space-between"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "center",
                  "align-items": "center"
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_TaskScenario") +
                        ":" +
                        _vm.ColumnUtils.showTypeLabelFunc(
                          _vm.form.taskScenario,
                          _vm.SystemConstants.TASK_SCENARIO_LIST
                        )
                    ) +
                    " "
                )
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success" },
                    on: { click: _vm.saveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.cancelHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "card",
                  "before-leave": function(activeName, oldActiveName) {
                    _vm.beforeLeaveTab(activeName, oldActiveName)
                  }
                },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ScenarioSettings"),
                      name: "scenarioSettings"
                    }
                  },
                  [
                    _c("scenario-settings", {
                      ref: "scenarioSettings",
                      on: {
                        refreshDone: _vm.refreshDoneHandler,
                        taskChange: _vm.taskChangeHandler
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_RuleSettings"),
                      name: "ruleSettings"
                    }
                  },
                  [
                    _vm.form.taskScenario ===
                    _vm.SystemConstants.TASK_SCENARIO_1.code
                      ? _c("rule-settings", {
                          ref: "ruleSettings",
                          on: {
                            ruleSettingChange: _vm.ruleSettingChangeHandler
                          }
                        })
                      : _vm._e(),
                    _vm.form.taskScenario ===
                    _vm.SystemConstants.TASK_SCENARIO_2.code
                      ? _c("settlement-rate-settings", {
                          ref: "ruleSettings",
                          on: {
                            ruleSettingChange: _vm.ruleSettingChangeHandler
                          }
                        })
                      : _vm._e(),
                    _vm.form.taskScenario ===
                      _vm.SystemConstants.TASK_SCENARIO_3.code ||
                    _vm.form.taskScenario ===
                      _vm.SystemConstants.TASK_SCENARIO_4.code ||
                    _vm.form.taskScenario ===
                      _vm.SystemConstants.TASK_SCENARIO_5.code
                      ? _c("mls-send-setting", {
                          ref: "ruleSettings",
                          attrs: { "task-scenario": _vm.form.taskScenario },
                          on: {
                            ruleSettingChange: _vm.ruleSettingChangeHandler
                          }
                        })
                      : _vm._e(),
                    _vm.form.taskScenario ===
                    _vm.SystemConstants.TASK_SCENARIO_6.code
                      ? _c("third-party-send-settings", {
                          ref: "ruleSettings",
                          attrs: { "task-scenario": _vm.form.taskScenario },
                          on: {
                            ruleSettingChange: _vm.ruleSettingChangeHandler
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_CommandSettings"),
                      name: "commandSettings"
                    }
                  },
                  [
                    _c("command-settings", {
                      ref: "commandSettings",
                      on: {
                        refreshDone: _vm.refreshDoneHandler,
                        ruleTaskChange: _vm.ruleTaskChangeHandler
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }